module.exports = __webpack_public_path__ + "static/media/ios-code-working.c84611ad.svg";